import { Component } from '@angular/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

@Component({
  standalone: false,
  selector: 'nimbus-wrong-location-page',
  templateUrl: './wrong-location-page.component.html',
  styleUrls: ['./wrong-location-page.component.scss'],
})
export class WrongLocationPageComponent {
  public TranslationKeys = TranslationKeys;
}
